var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "keyboard-wrapper"
  }, [_c('div', {
    staticClass: "keyboard-k2 lite Outline"
  }, _vm._l(_vm.keyboardData, function (rowValue, rowKey) {
    return _c('div', {
      key: rowKey,
      staticClass: "row dark",
      class: rowKey
    }, _vm._l(rowValue, function (value, key) {
      return _c('div', {
        key: key,
        staticClass: "ghosting active",
        class: key
      }, [_c('svg', {
        attrs: {
          "height": "67px",
          "width": _vm.getKeyWidth(key)
        },
        domProps: {
          "innerHTML": _vm._s(value)
        }
      })]);
    }), 0);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }